/* NORD MOTION — scroll-reveals, stagger en zachte parallax.
   Content wordt pas verborgen NADAT JS geladen is (geen FOUC / geen lege site zonder JS). */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var vh = window.innerHeight;

  /* ---------- 1. Scroll-reveal met stagger ---------- */
  function collectTargets() {
    var targets = [];
    // Directe blokken binnen secties
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      var groups = section.querySelectorAll(
        '.card-wrapper, .multicolumn-card, .collection-list__item, .grid__item, .image-with-text__grid, .rich-text__wrapper, .newsletter__wrapper, .collage__item'
      );
      if (groups.length) {
        groups.forEach(function (el) { targets.push(el); });
      } else {
        var inner = section.firstElementChild;
        if (inner && inner.tagName !== 'SCRIPT' && inner.tagName !== 'STYLE') {
          // FIX: wrappers die hoger zijn dan het scherm nooit verbergen.
          // Zo'n blok (bv. een hele custom-liquid pagina) kan de observer-drempel
          // niet halen en zou permanent op opacity:0 blijven staan.
          if (inner.getBoundingClientRect().height <= vh * 1.2) targets.push(inner);
        }
      }
    });
    return targets;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('nord-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -6% 0px' }); // FIX: threshold 0 i.p.v. 0.12

  function initReveal() {
    var staggerCounters = new WeakMap();
    collectTargets().forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // Elementen die al in beeld staan niet verstoppen
      if (rect.top < vh * 0.9 && rect.bottom > 0) return;
      var parent = el.parentElement || document.body;
      var idx = staggerCounters.get(parent) || 0;
      staggerCounters.set(parent, idx + 1);
      el.style.setProperty('--nord-delay', Math.min(idx * 90, 450) + 'ms');
      // Afwisselend links/rechts voor image-with-text blokken
      if (el.classList.contains('image-with-text__grid')) {
        el.classList.add(idx % 2 === 0 ? 'nord-reveal--left' : 'nord-reveal--right');
      }
      el.classList.add('nord-reveal');
      io.observe(el);
    });
  }

  /* FIX: vangnet. Alles wat na het laden in beeld staat maar nog verborgen is,
     wordt alsnog zichtbaar gemaakt. Blokken verder naar beneden houden gewoon
     hun scroll-animatie. */
  function rescueVisible() {
    document.querySelectorAll('.nord-reveal:not(.nord-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('nord-in');
    });
  }

  /* ---------- 2. Zachte parallax op hero- en sectiemedia ---------- */
  function initParallax() {
    var media = Array.prototype.slice.call(
      document.querySelectorAll('.banner__media img, .image-with-text__media img')
    ).slice(0, 6); // begrensd voor performance
    if (!media.length) return;
    media.forEach(function (img) { img.classList.add('nord-parallax'); });

    var ticking = false;
    function update() {
      media.forEach(function (img) {
        var rect = img.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -1 .. 1
        var shift = Math.max(-18, Math.min(18, progress * -14));
        img.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); initParallax(); });
  } else {
    initReveal();
    initParallax();
  }

  window.addEventListener('load', function () { setTimeout(rescueVisible, 250); });
  setTimeout(rescueVisible, 2500);
})();
